import { Transaction } from './transaction';

export class RemittanceTransaction extends Transaction {
  public paymentAmount!: number | null;
}
